<div class="emds">
  <div class="modal-default" id="file-upload-modal">
    <div class="modal-header">
      <span *ngIf="title">{{ title }}</span>
    </div>
    <div class="modal-body">
      <ap-alert></ap-alert>
      <ng-container *ngIf="message">
        <span>{{ message }}</span>
        <br>
        <br>
      </ng-container>
      <div class="form-group">
        <label for="file-upload-modal-file-picker" translate>File</label>
        <ap-file-upload
          baseId="file-upload-modal-file-picker"
          (filesChanged)="filesChanged($event)"
          (errorOutput)="displayError($event)"
          [allowedExtensions]="allowedExtensions"
          [maxFiles]="1"
          [required]="true"
          [fileUploadControlDisplayName]="'Selected File'"
        ></ap-file-upload>
      </div>
    </div>
    <div class="modal-footer">
      <button id="file-upload-modal-cancel"
              class="btn pull-right btn-flush-right"
              (click)="cancel()"
              translate>
          Cancel
      </button>
      <button id="file-upload-modal-ok"
              class="btn-primary btn pull-right"
              [disabled]="!selectedFile"
              (click)="close()"
              translate>
          Import
      </button>
    </div>
  </div>
</div>